// ProchainHoraire.js
// Composant affichant les prochaines ouvertures du planning
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale/fr';
import '../styles/ProchainHoraire.css';

// Composant principal ProchainHoraire
const ProchainHoraire = () => {
  const [ouvertAujourdhui, setOuvertAujourdhui] = useState(false);
  const [horairesJour, setHorairesJour] = useState([]);
  const [prochaineDateFormatee, setProchaineDateFormatee] = useState('');
  const [prochaineHoraires, setProchaineHoraires] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  useEffect(() => {
    const chargerHoraires = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${API_URL}/api/prochouvplanning`);
        const donnees = response.data;

        if (!donnees || donnees.length === 0) {
          setError('Aucune ouverture prévue pour les jours à venir.');
          return;
        }

        const today = new Date().toISOString().split('T')[0];
        const premiereDateBrute = donnees[0].date;
        const premiereDateAAMMJJ = premiereDateBrute.split('T')[0];

        // Filtrer tous les horaires du premier jour trouvé
        const horairesDuJour = donnees.filter(
          (h) => h.date.split('T')[0] === premiereDateAAMMJJ
        );

        if (premiereDateAAMMJJ === today) {
          // Le musée est ouvert aujourd'hui
          setOuvertAujourdhui(true);
          setHorairesJour(horairesDuJour.map((h) => h.horaire));
        } else {
          // Le musée est fermé aujourd'hui
          setOuvertAujourdhui(false);
          const dateFormatee = format(new Date(premiereDateBrute), 'EEEE dd MMMM yyyy', { locale: fr });
          setProchaineDateFormatee(dateFormatee);
          setProchaineHoraires(horairesDuJour.map((h) => h.horaire));
        }
      } catch (err) {
        setError('Erreur lors du chargement des horaires');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    chargerHoraires();
  }, []);

  return (
    <div className="prochainhoraire-container">
      {loading && <p>Chargement...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !error && (ouvertAujourdhui || prochaineDateFormatee) && (
        <div className="prochainhoraire-card">
          <span className="prochainhoraire-icon">
            {ouvertAujourdhui ? '🟢' : '🔴'}
          </span>
          <div className="prochainhoraire-content">
            <h3>Ouverture du musée</h3>
            {ouvertAujourdhui ? (
              <p className="prochainhoraire-message">
                Le musée est ouvert aujourd'hui {horairesJour.join(' et ')}
              </p>
            ) : (
              <p className="prochainhoraire-message">
                Le musée est fermé aujourd'hui, prochaine ouverture {' '}
                <strong>{prochaineDateFormatee}</strong> {' '}
                <strong>{prochaineHoraires.join(', ')}</strong>
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProchainHoraire;
